<script setup lang="ts">
import CalculationStepper from '../components/CalculationStepper.vue';

import { useCurrentSegment } from '../composables/useCurrentSegment';

const { currentSegment } = useCurrentSegment();
</script>

<template>
  <div class="space-y-9 py-6">
    <h1 class="font-lora text-3xl text-gray-900">
      {{ currentSegment?.name || $route.meta.title }}
    </h1>

    <div class="flex gap-6">
      <CalculationStepper class="h-max max-h-[70vh] shrink-0 basis-[354px] overflow-y-auto" />

      <RouterView class="flex-1" />
    </div>
  </div>
</template>
